<div class="fixed top-0 z-[199] h-[60px] w-full border-b border-[rgb(var(--ui-6))] bg-[rgb(var(--ui-7))] md:h-[64px]">
    <div
        class="box-border mx-auto flex h-full w-full max-w-[1560px] items-center justify-between gap-4 px-4 py-[10px] md:h-[64px] md:px-[60px] md:py-3"
    >
        <a
            class="flex min-w-0 flex-1 flex-row items-center justify-start gap-4 text-[var(--textColorSecondary)] no-underline hover:text-[var(--textColorSecondary)] hover:no-underline"
            [class.cursor-pointer]="logoInteractive()"
            routerLink="/"
            [tabindex]="logoInteractive() ? 0 : -1"
            [attr.aria-label]="homeAriaLabel()"
        >
            <div class="h-[28px] w-[110px] flex-none md:h-[31.25px] md:w-[125px]" aria-hidden="true">
                <img
                    class="block h-[28px] w-[110px] object-contain md:h-[31.25px] md:w-[125px]"
                    src="assets/images/shs/logo.svg"
                    alt=""
                />
            </div>
            <div
                class="font-shBreeHeadline min-w-0 flex-1 px-2 py-0 text-[14px] leading-5 text-[rgb(var(--ui-5))] md:whitespace-nowrap md:px-4 md:pt-1 md:text-[16px] md:leading-6"
            >
                {{ appName() }}
            </div>
        </a>
        @if (!hideUserControls()) {
            <div class="flex min-w-0 flex-1 basis-0 flex-row items-center justify-end gap-1">
                <app-language-switch [selectedLang]="selectedLang()" (languageChanged)="changeLanguage($event)" />
                @if (user(); as currentUser) {
                    <sh-user-identifier
                        class="ml-1 cursor-default"
                        [name]="currentUser.firstName + ' ' + currentUser.lastName"
                        [info]="currentUser.orgCode"
                        [initials]="(currentUser.firstName[0] + currentUser.lastName[0]).toUpperCase()"
                        [image]="
                            allowProfilePicture() && profilePicture() ? 'url(' + profilePicture() + ')' : undefined
                        "
                    />
                }
            </div>
        }
    </div>
</div>
